import React, { useState, useEffect, useContext } from "react";
import { Layout, Menu, message, Modal } from "antd";
import { Link, useLocation, useNavigate } from "react-router-dom";
import {
  AppstoreOutlined,
  MailOutlined,
  KeyOutlined,
  CreditCardOutlined,
  LogoutOutlined,
} from "@ant-design/icons";
import logo from "../../Assets/Images/Logo.svg";
import logoutIcon from "../../Assets/Icons/logout.svg";
import "./style.css";
import { handleLogout } from "../../Utlis/UpdateUsersState";
import { UserContext } from "../../App";

const { Sider } = Layout;

const Sidebar = ({ collapsed, setCollapsed, breakpoint }) => {
  const { setUserData, setUserToken } = useContext(UserContext);

  const location = useLocation();
  const [selectedId, setSelectedId] = useState("1");
  const [logoutModalVisible, setLogoutModalVisible] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const path = location.pathname;
    if (path.includes("/dashboard")) setSelectedId("1");
    else if (path.includes("/email-servers")) setSelectedId("2");
    else if (path.includes("/api-keys")) setSelectedId("3");
    else if (path.includes("/payment-details")) setSelectedId("4");
  }, [location.pathname]);

  const items = [
    {
      key: "1",
      icon: <AppstoreOutlined />,
      label: <Link to="/dashboard">Dashboard</Link>,
    },
    {
      key: "2",
      icon: <MailOutlined />,
      label: <Link to="/email-servers">Email Servers</Link>,
    },
    {
      key: "3",
      icon: <KeyOutlined />,
      label: <Link to="/api-keys">API Keys</Link>,
    },
    {
      key: "4",
      icon: <CreditCardOutlined />,
      label: <Link to="/payment-details">Payment Details</Link>,
    },
  ];

  const logoutItem = [
    {
      key: "logout",
      icon: <LogoutOutlined />,
      label: <span>Logout</span>,
    },
  ];

  const handleMenuClick = (e) => {
    if (e.key === "logout") {
      setLogoutModalVisible(true);
    } else {
      setSelectedId(e.key);
    }
  };

  return (
    <>
      <Sider
        className="sidebar"
        width={240}
        collapsible
        collapsed={collapsed}
        onCollapse={(val) => setCollapsed(val)}
        collapsedWidth={0}
        breakpoint={breakpoint}
        theme="light"
        style={{ height: "100vh", position: "fixed" }}
      >
        <div className="logo-container">
          <img src={logo} alt="logo" style={{ width: "149px" }} />
        </div>

        <div
          style={{
            display: "flex",
            flexDirection: "column",
            height: "calc(100% - 80px)",
          }}
        >
          <Menu
            mode="inline"
            theme="light"
            selectedKeys={[selectedId]}
            items={items}
            style={{ flex: 1 }}
            onClick={handleMenuClick}
          />

          <Menu
            mode="inline"
            theme="light"
            selectedKeys={[selectedId]}
            items={logoutItem}
            onClick={handleMenuClick}
            style={{
              marginBottom: 8,
            }}
          />
        </div>
      </Sider>
      <Modal
        className="logout-modal"
        open={logoutModalVisible}
        title={
          <div className="modal-text">
            <img
              src={logoutIcon}
              alt="logout"
              style={{
                width: 56,
                height: 56,
                borderRadius: 8,
                backgroundColor: "#F35D371A",
              }}
            />
            <div className="logout-text">
              <span>Log out?</span>
              <p>
                Are you sure you want to log out of your Inbixio account? You
                will need to log in again to access your dashboard.
              </p>
            </div>
          </div>
        }
        okText="Logout"
        cancelText="Cancel"
        centered
        onOk={() => {
          message.success("Logged out successfully");
          handleLogout(setUserData, setUserToken);
          navigate("/login");
          setLogoutModalVisible(false);
        }}
        onCancel={() => setLogoutModalVisible(false)}
      />
    </>
  );
};

export default Sidebar;
